import React from "react";
import { Link } from "gatsby"

import { Container, Row, Col } from "reusecore/Layout";
import Box from "reusecore/Box";
import Badge from "reusecore/Badge";
import Heading from "reusecore/Heading";
import Text from "reusecore/Text";
import Image from "reusecore/Image";

import BannerImage from "assets/images/header.png";

import particleTopLeft from "assets/images/particles/banner/particle-top-left.png";
import particleUnderLogo from "assets/images/particles/banner/particle-under-logo.png";
import prticleTopRight from "assets/images/particles/banner/prticle-top-right.png";
import particleBottomLeft from "assets/images/particles/banner/particle-bottom-left.png";
import particleBottomRight from "assets/images/particles/banner/particle-bottom-right.png";

import {FaGlasses} from 'react-icons/fa'
import {FaMask} from 'react-icons/fa'
import {FaStopwatch} from 'react-icons/fa'
import {FaRobot} from 'react-icons/fa'


import BannerWrapper from "./banner.style";

const BannerTwo = () => {
  return (
    <BannerWrapper id="inicio">
      <img src={particleTopLeft} className="section__particle top-left" alt="cryptik particles"/>
      <img src={particleUnderLogo} className="section__particle two" alt="cryptik particles"/>
      <img src={prticleTopRight} className="section__particle top-right" alt="cryptik particles"/>
      <img src={particleBottomLeft} className="section__particle bottom-left" alt="cryptik particles"/>
      <img src={particleBottomRight} className="section__particle bottom-right" alt="cryptik particles"/>
      <Container>

        <Row>
     
          <Col className="lg-7 md-10 xs-12">
            <Box className="banner-content"> 
              <Heading>
                <h1>WEB SCRAPING</h1>
                Extraemos la data que necesitas
              </Heading>
              <Text as="span" className="description">
              Potencia tu negocio automatizando la extracción de información sobre precios, inventarios, eventos, campañas publicitarias, datos de prospectos, entre otros. 
              </Text>

              <Box className="coin-info">
                <Box>
                  <FaMask size="1.7em" color="#BEABDF"/>
                  <Text>&nbsp;&nbsp;Anonimato</Text>
                </Box>
                <Box>
                  <FaStopwatch size="1.7em"   color="#BEABDF"/>
                  <Text>&nbsp;&nbsp;Velocidad</Text>
                </Box>
                <Box>
                  <FaRobot size="1.7em"  color="#BEABDF"/>
                  <Text>&nbsp;&nbsp;Automatizado</Text>
                </Box>
              </Box>

              <Box className="banner-btn">
                <Link to="#service" className="btn btn-fill">
                   <FaGlasses /> Ver más
                </Link> 
              </Box>
            </Box>
          </Col>
          <Col className="lg-5 md-2 xs-12">   <img src={BannerImage} /></Col>
        </Row>
      </Container>
    </BannerWrapper>
  );
};

export default BannerTwo;
